<div class="date-filter-container">
  <button
    nz-button
    nz-popover
    nzPopoverTrigger="click"
    [nzPopoverContent]="contentTemplate"
    nzPopoverPlacement="bottomLeft"
    (nzPopoverVisibleChange)="popoverChange()"
    [ngStyle]="{
      color: lblVal === '' ? 'black' : validDate === true ? '#36abad' : 'red',
      borderColor: lblVal === '' ? '' : validDate === true ? '#36abad' : 'red'
    }"
  >
    <span *ngIf="!lblVal">Date Published</span>
    <span *ngIf="lblVal">{{ lblVal }}</span>
    <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="down-arrow"></i>
  </button>

  <ng-template #contentTemplate>
    <ul nz-menu class="list-style">
      <li nz-menu-item>
        <nz-radio-group [(ngModel)]="radioValue">
          <label
            nz-radio
            [nzValue]="o.value"
            class="radio-opt"
            *ngFor="let o of options"
            >{{ o.label }}</label
          >
          <label nz-radio nzValue="choose" class="radio-opt choose-opt"
            >Choose a date range
            <div class="date-picker-wrapper">
              <!-- nzFormat="dd-MM-yyyy" -->
              <nz-date-picker class="date-picker"
                [nzDisabledDate]="disabledStartDate"
                [nzSize]="'small'"
                nzPlaceHolder="yyyy-mm-dd"
                [(ngModel)]="customStartDate"
                (ngModelChange)="startDateChange($event)"
              ></nz-date-picker>
              <nz-date-picker class="date-picker"
                [nzSize]="'small'"
                [nzDisabledDate]="disabledEndDate"
                nzPlaceHolder="yyyy-mm-dd"
                [(ngModel)]="customEndDate"
                (ngModelChange)="endDateChange($event)"
              ></nz-date-picker>
            </div>
          </label>
        </nz-radio-group>
      </li>
      <li nz-menu-divider></li>
      <li class="reset" (click)="reset()">
        <va-icon size="small" name="redo" class="fa-sm reset-icon"></va-icon>
        <label class="reset-lbl">Reset</label>
      </li>
    </ul>
  </ng-template>
</div>
